import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { SongResultsRow } from '../outreachTypes';
import { useRetry } from './useRetry';

/** `outreach.campaigns.resultsAll` (design outreach-v2 n2): every campaign of the artist side by side. */
export function useResultsAll(accountId: number) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(trpcAPI.outreach.campaigns.resultsAll.queryOptions({ accountId }, { retry: false }));
  const retry = useRetry(query.refetch);
  return {
    rows: (query.data as SongResultsRow[] | null | undefined) ?? undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
